
//packages
import axios from "axios";

export const putExamToken = (tokenAmount, userEmail, refreshHook=null) => {
    const token = localStorage.getItem('access_token');
    axios
    .put(`${process.env.REACT_APP_API_BASE_URL}/api/give-user-token/`, {
        token_give_amount: tokenAmount,
        user_email: userEmail,
    },{
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      if (response.status === 200) {
      }
    })
    .catch((error) => {
        console.log(error);
    })
};